import type { ChangeEventHandler, FC, HTMLInputTypeAttribute, ReactElement } from 'react'
import { useState } from 'react'

import SearchIcon from 'mdi-react/SearchIcon'
import { nanoid } from 'nanoid'

import './input.scss'

type InputProps = {
  type?: HTMLInputTypeAttribute
  className?: string
  label?: string | ReactElement
  filter?: boolean
  onChange: ChangeEventHandler<HTMLInputElement> | undefined
  [k: string]: unknown
}

const Input: FC<InputProps> = ({
  label,
  className = '',
  type = 'text',
  filter = false,
  onChange,
  ...restOfProps
}) => {
  const [id] = useState(nanoid())

  return (
    <div className={`input-container ${className} ${filter ? 'filter' : 'regular'}`}>
      {label && <label htmlFor={id}>{label}</label>}

      {filter && <SearchIcon />}

      <input type={type} id={id} onChange={onChange} {...restOfProps} />
    </div>
  )
}

export const FilterInput = (props: InputProps) => <Input {...props} filter={true} />

export default Input
